import { useField } from 'formik'
import { Ref, useCallback } from 'react'
import { Checkbox as AntdCheckbox } from '../../Checkbox'
import type {
  CheckboxChangeEvent as AntdCheckboxChangeEvent,
  CheckboxProps as AntdCheckboxProps,
  CheckboxOptionType as AntdCheckboxOptionType,
  CheckboxRef as AntdCheckboxRef
} from '../../Checkbox'
import type { FormikFieldProps } from '../typings/FieldProps'

export type CheckboxOptionType = AntdCheckboxOptionType
export type CheckboxProps = FormikFieldProps &
  AntdCheckboxProps & {
    ref?: Ref<CheckboxRef>
  }
export type CheckboxRef = AntdCheckboxRef

export const Checkbox = ({
  name,
  onChange: onChangeProp,
  ...restProps
}: CheckboxProps) => {
  const [field, , helpers] = useField(name)
  const { value } = field
  const { setValue, setTouched } = helpers

  const handleChange = useCallback(
    (event: AntdCheckboxChangeEvent) => {
      setValue(event.target.checked)
      onChangeProp?.(event)
      setTimeout(() => setTouched(true), 0)
    },
    [onChangeProp, setTouched, setValue]
  )

  return (
    <AntdCheckbox
      name={name}
      checked={value}
      onChange={handleChange}
      {...restProps}
    />
  )
}
